<template>
  <MainBoard msg="Tic tak"/>
  <div class="winner"></div>

</template>

<script>
import MainBoard from './components/MainBoard.vue'

export default {
  name: 'App',
  components: {
    MainBoard
  }
}
</script>

<style>
* {
  background-color: rgb(14,11,39);
}
#app {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 30px;
  text-align: center;
  font-weight: bold;
  margin-top: 50px;
  color: magenta;
}
.winner {
  color:red;
}


</style>
